import { config } from 'config'
import { Strings } from 'models'

export const buildObjects = <T extends object>(data: {
  values: Array<string[]>
}) => {
  const dataCopy = data.values.slice()
  const columnNames = dataCopy.shift() as string[]

  const parsedData = dataCopy.map((row, rowIndex) =>
    row.reduce(
      (acc, value, index) => {
        const columnName = columnNames[index]?.toLowerCase()

        if (!value || !columnName) {
          return acc
        }

        return {
          ...acc,
          [columnName]:
            acc[columnName as keyof typeof acc] &&
            Array.isArray(acc[columnName as keyof typeof acc])
              ? [
                  ...(acc[columnName as keyof typeof acc] as unknown as any[]),
                  value,
                ]
              : acc[columnName as keyof typeof acc]
              ? [acc[columnName as keyof typeof acc], value]
              : value,
        }
      },
      { id: rowIndex + 1 } as T
    )
  )

  return parsedData
}

export const buildStrings = (data: { values: Array<string[]> }) =>
  buildObjects<{ key: string; content: string }>(data).reduce(
    (acc, item) => ({
      ...acc,
      [item.key]: item.content,
    }),
    {} as Strings
  )

export const getAge = (yearOfBirth: string) => {
  if (!yearOfBirth) {
    return ''
  }

  const birthYearNum = Number(yearOfBirth)

  if (isNaN(birthYearNum)) {
    return ''
  }

  return config.yearNow - birthYearNum
}
